import { render, staticRenderFns } from "./jtingView.vue?vue&type=template&id=2416e8b8&scoped=true"
import script from "./jtingView.vue?vue&type=script&lang=js"
export * from "./jtingView.vue?vue&type=script&lang=js"
import style0 from "./jtingView.vue?vue&type=style&index=0&id=2416e8b8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2416e8b8",
  null
  
)

export default component.exports